"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function ModCategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="animate-pulse rounded-md border border-border bg-muted/20">
            <AspectRatio ratio={16 / 9} />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-destructive">
        <p className="font-default text-lg">Error loading packaging categories.</p>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p className="font-default text-lg">No categories found.</p>
      </div>;
  }
  return <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {terms.map((term, i) => <Link key={term.id} to={term.link || "/ShopPage"} data-index={i} className="group relative block overflow-hidden rounded-md border border-muted bg-card transition-all duration-500 hover:border-primary hover:shadow-md">
          <AspectRatio ratio={16 / 9}>
            {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted/30">
                <span className="font-mono text-sm text-muted-foreground uppercase tracking-widest">
                  PACKLUX
                </span>
              </div>}
            
            {}
            <div className="absolute inset-0 bg-primary/20 opacity-0 transition-opacity duration-500 group-hover:opacity-60" />
            
            {}
            <div className="absolute inset-0 flex items-center justify-center p-4">
              <div className="rounded-md border border-border/20 bg-card/80 px-6 py-3 backdrop-blur-md transition-transform duration-500 group-hover:scale-105 group-hover:bg-card">
                <h3 className="font-default text-xl font-bold uppercase tracking-tighter text-foreground">
                  {term.name}
                </h3>
              </div>
            </div>
          </AspectRatio>
        </Link>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 4,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function ModCategories() {
  return <section data-section-id="245736" id="products" className="bg-background px-4 py-16 text-foreground sm:py-24">
      <div className="mx-auto mb-12 max-w-7xl text-center">
        <h2 className="font-default text-3xl font-bold uppercase tracking-tighter text-foreground sm:text-4xl">
          Sustainable <span className="text-primary">Packaging</span>
        </h2>
        <p className="mt-4 font-default text-muted-foreground max-w-2xl mx-auto">
          Explore our range of responsibly sourced kraft paper solutions and biodegradable bags designed for modern food service.
        </p>
      </div>

      <EcommerceTermsProvider className="mod-categories-wrapper" wp_term_query={wp_term_query}>
        <ModCategoriesConsumer />
      </EcommerceTermsProvider>
    </section>;
}